import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';

export function* scrollToTop(): SagaIterator {
    yield call<ScrollToOptions>(window.scrollTo, {
        top: 0,
        behavior: 'auto',
    });
}
